import axios from "axios";

export const getFeaturedJobGroupsDisplay = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredjobgroupsdisplay/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editFeaturedJobGroupsDisplay = (careersClientId, data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredjobgroupsdisplay/editfeaturedjobgroupsconfiguration/" +
        encodeURIComponent(careersClientId),
      data
    )
    .then((res) => res.data);
};
